// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import DataViewer from '../core/data-viewer';
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-freewheel-ad-request.scss';

const servicesDataKey = 'mediaItemFreewheelAdRequest';

function FreewheelAdRequest({ dependentSearchValues, error, fetching, servicesSearchData: { searchData } }) {
  const getMediaItemFarallonGuid = () => [{ farallonGuid: get(dependentSearchValues, 'content.0.externalGuid') }];

  const renderDataViewer = () => (!error ? (
            <div className="mediaitem-freewheel-ad-request--record-details">
                <DataViewer searchData={[searchData]} showEditor={true} />
            </div>
        ) : (
            <div className="mediaitem-freewheel-ad-request--no-items">
                Freewheel ad data not available for this Media Item.
            </div>
        ));

  return getMediaItemFarallonGuid() ? (
        <div className="mediaitem-freewheel-ad-request">
            <div className="mediaItem-freewheel-ad-request--content">
                <div className="mediaitem-freewheel-ad-request--title">Farallon Infogs</div>
                <div className="mediaitem-freewheel-ad-request--record-details">
                    <RecordDetails searchData={getMediaItemFarallonGuid()} />
                </div>
                <div className="mediaitem-freewheel-ad-request--title">Freewheel Ad Request URL</div>
                {renderDataViewer()}
                <Loading loading={fetching} />
            </div>
        </div>
  ) : (
        <Error error="Choose a record." />
  );
}

FreewheelAdRequest.propTypes = {
    dependentSearchValues: PropTypes.object,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    servicesSearchData: PropTypes.object.isRequired,
};

export default withSearch(FreewheelAdRequest, servicesDataKey);
